import { Link } from "@tanstack/react-router"
import type { Tool } from "@/data/tools/tools-registry"
import { getCategoryLabel } from "@/data/tools/tools-registry"
import { useTranslation } from "@/lib/i18n"

type RelatedToolsProps = {
  tools: Tool[]
}

export default function RelatedTools({ tools }: RelatedToolsProps) {
  const { translations: t } = useTranslation()

  return (
    <section className="w-full py-12 sm:py-16 px-4 sm:px-6">
      <div className="max-w-5xl mx-auto">
        <div className="text-center mb-8">
          <h2 className="text-xl sm:text-2xl font-bold text-neutral-900 dark:text-white tracking-tight">
            {t.toolsPage.relatedTools}
          </h2>
          <p className="text-sm text-neutral-500 dark:text-neutral-400 mt-1 font-medium">
            {t.toolsPage.relatedToolsDesc}
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
          {tools.slice(0, 4).map((tool) => {
            const isLive = tool.status === "live"
            return (
              <Link
                key={tool.slug}
                to={(isLive ? `/tools/${tool.slug}` : "/tools") as "/tools"}
                className="group p-4 rounded-xl border border-neutral-200 dark:border-neutral-800 bg-white dark:bg-neutral-900/50 hover:border-neutral-300 dark:hover:border-neutral-700 hover:shadow-md transition-all duration-300"
              >
                <span className="text-xs font-semibold text-neutral-400 dark:text-neutral-500 uppercase tracking-wider">
                  {getCategoryLabel(tool.category)}
                </span>
                <h3 className="text-sm font-bold text-neutral-900 dark:text-white mt-1 group-hover:text-brand-button transition-colors">
                  {tool.shortName}
                </h3>
                <p className="text-xs text-neutral-500 dark:text-neutral-400 mt-1 line-clamp-2">
                  {tool.description}
                </p>
              </Link>
            )
          })}
        </div>

        <div className="text-center mt-6">
          <Link
            to="/tools"
            className="text-sm font-semibold text-brand-button hover:text-brand-button-hover transition-colors"
          >
            {t.toolsPage.viewAllTools} &rarr;
          </Link>
        </div>
      </div>
    </section>
  )
}
